import { UserPreferencesSaveRequest } from "@/main/models/request/userPreferencesRequest";
import { UserResponse } from "@models/response/userResponse";

export enum UserTypes {
	USER_SIGNIN = "@user/USER_SIGNIN",
	USER_SET_CURRENT = "@user/USER_SET_CURRENT",
	USER_ISLOGOUT = "@user/USER_ISLOGOUT",
	GET_USER_PREFERENCES = "@user/GET_USER_PREFERENCES",
	SAVE_USER_PREFERENCES = "@user/SAVE_USER_PREFERENCES",
	USER_OPEN_MODALUSER_CHANGEPASSWORD_ALERT = "@user/USER_OPEN_MODALUSER_CHANGEPASSWORD_ALERT",
}

export interface UserState {
	readonly currentUser: UserResponse | null;
	readonly userPreference: {
		preferences: UserPreferencesSaveRequest;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
	readonly openModalUserChangePasswordAlert: boolean;
	readonly numberOfDaysToPasswordExpires: number | null;
}

export interface UserSignIn {
	type: typeof UserTypes.USER_SIGNIN;
	payload: {
		email: string;
		password: string;
	};
}

export interface UserSetCurrent {
	type: typeof UserTypes.USER_SET_CURRENT;
	payload: UserResponse | null;
}

export interface SaveUserPreferences {
	type: typeof UserTypes.SAVE_USER_PREFERENCES;
	payload: {
		preferences: UserPreferencesSaveRequest | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface GetUserPreferences {
	type: typeof UserTypes.GET_USER_PREFERENCES;
}

export interface UserOpenModalUserChangePasswordAlert {
	type: typeof UserTypes.USER_OPEN_MODALUSER_CHANGEPASSWORD_ALERT;
	payload: {
		open: boolean;
		numberOfDaysToPasswordExpires: number | null;
	};
}

export type UserActionTypes =
	| UserSignIn
	| UserSetCurrent
	| SaveUserPreferences
	| GetUserPreferences
	| UserOpenModalUserChangePasswordAlert;
